import React, { useMemo, useState } from "react"
import { Row, Col, Card, CardBody, Table, CardTitle } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import moment from "moment"
import { json } from "react-router-dom"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonTableContainer
        columns={columns}
        data={data}
      // status={true}
      />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ViewProposal = ({ customer_proposal }) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "pro_id",
        isInfoIcon: false,
        className: "pro_id",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.id || "-"}
            </div>
          )
        }
      },
      // {
      //   Header: "Assignee",
      //   accessor: "pro_assignee",
      //   isInfoIcon: false,
      //   className: "pro_assignee",
      //   Cell: cellprops => {
      //     return (
      //       <div className="">
      //         {cellprops.row.original?.assinged_name || "-"}
      //       </div>
      //     )
      //   }
      // },
      {
        Header: "Name",
        accessor: "pro_name",
        isInfoIcon: false,
        className: "pro_name",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.contactname || "-"}
            </div>
          )
        }
      },
      {
        Header: "Type",
        accessor: "pro_type",
        isInfoIcon: false,
        className: "pro_type",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.type || "-"}
            </div>
          )
        }
      },
      {
        Header: "Price",
        accessor: "pro_price",
        isInfoIcon: false,
        className: "pro_price",
        Cell: cellprops => {
          const array = JSON.parse(cellprops.row.original?.costbreakdown)
          const totalSum = array?.reduce((accumulator, item) => {
            const totalValue = parseFloat(item.totalcost) // Convert "total" to a number
            if (!isNaN(totalValue)) {
              return accumulator + totalValue
            }
            return accumulator // Skip items with invalid "total" values
          }, 0)
          return (
            <div className="">
              {cellprops?.row?.original?.currency_symbol} {totalSum || "0"}
            </div>
          )
        }
      },
      {
        Header: "Created At",
        accessor: "pro_created",
        isInfoIcon: false,
        className: "pro_created",
        Cell: cellprops => {
          return (
            <div className="">
              {moment(cellprops.row.original?.created_at).format("YYYY-MM-DD") || "-"}
            </div>
          )
        }
      },
      {
        Header: "Open Till",
        accessor: "pro_till",
        isInfoIcon: false,
        className: "pro_till",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.opentill || "-"}
            </div>
          )
        }
      },
      {
        Header: "Status",
        accessor: "pro_status",
        isInfoIcon: false,
        className: "pro_status",
        Cell: cellProps => {
          return (
            <span className={cellProps.row.original?.status_details[0]?.color + " badge"}>
              {cellProps.row.original?.status_details[0]?.name}
            </span>
          )

        }
      },
    ],
    []
  )

  // const data = [
  //   {
  //     pro_id : 1,
  //     pro_assignee : "Ryan",
  //     pro_name: "Zithas Tchnologies", 
  //     pro_type: "Zithas Proposal",
  //     pro_coins: "₹",
  //     pro_price: "10,000",
  //     pro_created: "08-12-2024",
  //     pro_till: "18-12-2024",
  //     pro_status: "sent"
  //   },
  //   {
  //     pro_id : 2,
  //     pro_assignee : "Eva",
  //     pro_name: "Zithas Tchnologies", 
  //     pro_type: "Zithas Proposal",
  //     pro_coins: "₹",
  //     pro_price: "10,000",
  //     pro_created: "08-12-2024",
  //     pro_till: "18-12-2024",
  //     pro_status: "sent"
  //   },
  //   {
  //     pro_id : 3,
  //     pro_assignee : "Ryan",
  //     pro_name: "Zithas Tchnologies", 
  //     pro_type: "Zithas Proposal",
  //     pro_coins: "₹",
  //     pro_price: "10,000",
  //     pro_created: "08-12-2024",
  //     pro_till: "18-12-2024",
  //     pro_status: "won"
  //   },
  //   {
  //     pro_id : 4,
  //     pro_assignee : "Eva",
  //     pro_name: "Zithas Tchnologies", 
  //     pro_type: "Zithas Proposal",
  //     pro_coins: "₹",
  //     pro_price: "10,000",
  //     pro_created: "08-12-2024",
  //     pro_till: "18-12-2024",
  //     pro_status: "sent"
  //   },
  //   {
  //     pro_id : 5,
  //     pro_assignee : "Ryan",
  //     pro_name: "Zithas Tchnologies", 
  //     pro_type: "Zithas Proposal",
  //     pro_coins: "₹",
  //     pro_price: "10,000",
  //     pro_created: "08-12-2024",
  //     pro_till: "18-12-2024",
  //     pro_status: "lost"
  //   },

  // ]

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 text-dark">Proposal</CardTitle>

                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={customer_proposal || []}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewProposal
